//import Footer from '../components/home/footer/Footer'
//import Header from '../components/home/header/Header'
import Shreya from '../../../assets/images/Shreya.jpg'
import Seray from '../../../assets/images/SerayKocDisli.png'
import Mantas from '../../../assets/images/Mantas.jpeg'
import Nazar from '../../../assets/images/nazar.jpg'
import Abhinav from '../../../assets/images/abhinav.jpg'
import Anton from '../../../assets/images/anton.jpg'
import './team.css';
const TeamSection = () => (
  /* 👇 anchor target for the nav link */
  <section id="team" className="teamSection">
    <div className="container">
      <p className="title">Our team</p>

      <div className="teamContainer">
        <div className="member">
          <div className="namesContainer">
            <p className="name">Shreya Kohli</p>
            <p className="name role">Founder</p>
          </div>
          <img className="memberImage" src={Shreya} alt="Shreya Kohli" />
        </div>

        <div className="member">
          <div className="namesContainer">
            <p className="name">Abhinav Singh</p>
            <p className="name role">Technical Architect</p>
          </div>
          <img className="memberImage" src={Abhinav} alt="Abhinav Singh" />
        </div>
        <div className="member">
          <div className="namesContainer">
            <p className="name">Nazar Tymiv</p>
            <p className="name role">Full-Stack Developer</p>
          </div>
          <img className="memberImage" src={Nazar} alt="Nazar Tymiv" />
        </div>
      </div>

      <p className="title">Contributors</p>
      <div className="teamContainer">
        <div className="member">
          <div className="namesContainer">
            <p className="name">Anton Carlstedt</p>
            <p className="name role">UX/UI Designer</p>
          </div>
          <img className="memberImage" src={Anton} alt="Anton Carlstedt" />
        </div>
        <div className="member">
          <div className="namesContainer">
            <p className="name">Mantas Navickis</p>
            <p className="name role">Full-Stack Developer</p>
          </div>
          <img className="memberImage" src={Mantas} alt="Mantas Navickis" />
        </div>

        <div className="member">
          <div className="namesContainer">
            <p className="name">Seray Koç</p>
            <p className="name role">UX/UI Designer</p>
          </div>
          <img className="memberImage" src={Seray} alt="Seray Koç" />
        </div>
      </div>
      
    </div>
  </section>
);

export default TeamSection;
/* const Team = ({ openReg, setOpenReg, setOpenAuth, openAuth, handleAuth }) => {
  return (
    <>
      <Header
        openReg={openReg}
        setOpenReg={setOpenReg}
        openAuth={openAuth}
        setOpenAuth={setOpenAuth}
        handleAuth={handleAuth}
      />
      <div className="container">
        <p className="title">Our team</p>
        <div className="teamContainer">
          <div className="member">
            <div className="namesContainer">
              <p className="name">Shreya Kohli</p>
              <p className="name role">Founder</p>
            </div>

            <img className="memberImage" src={Shreya} />
          </div>
          <div className="member">
            <div className="namesContainer">
              <p className="name">Abhinav Singh</p>
              <p className="name role"></p>
            </div>
            {
            <img className="memberImage" src={} /> }
          </div>
          <div className="member">
            <div className="namesContainer">
              <p className="name">Mantas Navickis</p>
              <p className="name role">Full Stack Developer</p>
            </div>

            <img className="memberImage" src={Mantas} />
          </div>
          <div className="member">
            <div className="namesContainer">
              <p className="name">Seray Koç</p>
              <p className="name role">UX/UI Designer</p>
            </div>

            <img className="memberImage" src={Seray} />
          </div>
        </div>
        <p className="title">Contributors</p>
        <div className="teamContainer">
          <div className="member">
            <div className="namesContainer">
              <p className="name">Anton Carlstedt</p>
              <p className="name role">UX/UI Designer</p>
            </div>

            {<img className="memberImage" src={} /> }
          </div>
        </div>
      </div>
      <Footer
        openReg={openReg}
        setOpenReg={setOpenReg}
        openAuth={openAuth}
        setOpenAuth={setOpenAuth}
        handleAuth={handleAuth}
      />
    </>
  )
}
export default Team */
